import { TipoEvaluacion } from './tipo-evaluacion.model';

export class DimensionRiesgo
{
    nombre: string;
    //tipoEvaluacion: TipoEvaluacion;
    categorias: string[];
    descripcion: string;
    id: number;
    bloqueado: boolean;
    /**
     * Constructor
     *
     * @param dimension
     */
    constructor(dimension)
    {
        {
            this.id = dimension.id || null;
            this.nombre = dimension.nombre || '';
            //this.tipoEvaluacion = dimension.tipoEvaluacion || null;
            this.descripcion = dimension.descripcion || '';
            this.categorias = dimension.categorias || [];
            this.bloqueado = dimension.bloqueado || false;
        }
    }
}
